import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { ViewEncapsulation, Component } from '@angular/core';
const _c0 = ["*"];
let HeaderComponent = /*#__PURE__*/(() => {
  class HeaderComponent {
    static {
      this.ɵfac = function HeaderComponent_Factory(t) {
        return new (t || HeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderComponent,
        selectors: [["pds-header"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 0,
        template: function HeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "header");
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule],
        encapsulation: 2
      });
    }
  }
  return HeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderComponent };
